import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import { CircularProgress } from '@mui/material';

const PageLoader = () => {
    return(
        <Backdrop 
            sx={{ 
                zIndex: (theme) => theme.zIndex.drawer + 1,
                color: '#fff',
            }} 
            open
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
    )
}


export default PageLoader;